export const API_KEY = '';
export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const endpoints = {
  // Data
  displayData: `${BASE_URL}/data.php`,
  recentData: `${BASE_URL}/recent.php`,
  getHistory: `${BASE_URL}/history.php`,
  getCHHistory: `${BASE_URL}/ch.php`,
  deleteHistory: `${BASE_URL}/delete.php`,
  deleteCHHistory: `${BASE_URL}/delete-ch.php`,
  login: `${BASE_URL}/auth.php`,
  userInsert: `${BASE_URL}/user_insert.php`,
  allData: `${BASE_URL}/all-data.php`,
  managedData: `${BASE_URL}/managed-data.php`,
  deleteData: `${BASE_URL}/delete-data.php`,
};